/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import { checkIsActive } from "../../../_metronic/_helpers";
import { pagesLinks } from "../../../utils/PageUtils";
import { hasRoleAccess } from "../../../utils/AuthUtils";

const AsideMenuListContainer = (props) => {
  const location = useLocation();
  const layoutProps = props.layoutProps;
  const getMenuItemActive = (url, hasSubmenu) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
      : "";
  };

  useEffect(() => {}, []);

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/", false)}`}
          aria-haspopup="true"
        >
          {hasRoleAccess(process.env.REACT_APP_HOME_ROLES) && (
            <NavLink className="menu-link" to="/" exact>
              <div className="menu-icon menu-svg-home"></div>
              <span className="menu-text">Home</span>
            </NavLink>
          )}
          {hasRoleAccess(process.env.REACT_APP_FEED_ROLES) && (
            <NavLink className="menu-link" to="/feed">
              <div className="menu-icon menu-svg-Feed"></div>
              <span className="menu-text">Caricamento Massivo</span>
            </NavLink>
          )}
          {hasRoleAccess(process.env.REACT_APP_MANAGEMENT_ROLES) && (
            <NavLink className="menu-link" to="/management">
              <div className="menu-icon menu-svg-management"></div>
              <span className="menu-text">Consultazione</span>
            </NavLink>
          )}
          {hasRoleAccess(process.env.REACT_APP_SEARCH_ROLES) && (
            <NavLink className="menu-link" to="/search">
              <div className="menu-icon menu-svg-search"></div>
              <span className="menu-text">Verifica Puntuale</span>
            </NavLink>
          )}
          {hasRoleAccess(process.env.REACT_APP_VERIFY_ROLES) && (
            <NavLink className="menu-link" to="/verify">
              <div className="menu-icon menu-svg-verify"></div>
              <span className="menu-text">Verifica Massiva</span>
            </NavLink>
          )}
          {hasRoleAccess(process.env.REACT_APP_AUDIT_ROLES) && (
            <NavLink className="menu-link" to="/audit">
              <div className="menu-icon menu-svg-audit"></div>
              <span className="menu-text">Audit</span>
            </NavLink>
          )}
        </li>
      </ul>

      {/* end::Menu Nav */}
    </>
  );
};

const mapStateToProps = function(state) {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export const AsideMenuList = connect(
  mapStateToProps,
  mapDispatchToProps
)(AsideMenuListContainer);
